<script>
import FormSelect from '../form/form-select.vue'
import formFieldMixin from './form-field-mixin.js'

export default {
  components: {
    FormSelect
  },
  mixins: [
    formFieldMixin
  ],
  props: {
  },
  computed: {
    taxRateOptions () {
      // FIXME: change to sub store when implemented API side.
      return [{value: null, text: '-'}].concat(this.$store.getters['taxrate/list/items'].map(
        item => {
          return {value: item.taxRate, text: item.name}
        }
      ))
    }
  },
  mounted () {
    this.$store.dispatch('taxrate/list/default')
  }
}
</script>
<template>
  <form-select
    :store="store"
    :translation-root="translationRoot"
    :prop-name="propName"
    :hide-label="hideLabel"
    :options="taxRateOptions"
  >
  </form-select>
</template>
